

// New Otp Script
function btnInbox(inbox) {

  if (inbox != undefined && inbox.url != undefined) {
    $('.btn_box').show();
    $('.EmailOtp').find('.btn-p > div').text(inbox.title);
    $('.EmailOtp').find('.btn-p').attr('href', inbox.url);
    s = $('.EmailOtp').find('.btn-p .icon_a > use').attr('href').split("#");
    $('.EmailOtp').find('.btn-p .icon_a > use').attr('href', s[0] + '#' + inbox.name)

  } else {
    $('.btn_box').hide();

  }
}
/**
 * Move focus between OTP boxes WITHOUT letting the browser scroll the new box into view.
 *
 * The boxes auto-advance on every digit, and a plain .focus() makes iOS scroll the focused
 * input into view each time. Inside a modal pinned to the viewport that reads as the whole
 * dialog jumping up and down while the code is typed. `preventScroll` is ignored by browsers
 * that do not support it, which simply leaves the previous behaviour.
 */
function focusOtpInput($input) {
  var el = $input && $input[0];

  if (!el) {
    return;
  }

  try {
    el.focus({ preventScroll: true });
  } catch (e) {
    el.focus();
  }
}

function createOtpInputs(length) {
  l = 4;
  if (length != undefined) {
    l = length;
  }
  input_bloc = '';
  for (i = 1; i <= l; i++) {
    input_bloc += ' <input type="number" maxlength="1" class="otp-input" name="otp[]" autocomplete="one-time-code"/>';
  }

  $('.otp_container:not([name="pin"])').html(input_bloc);

}

function toggleShow(iconElement) {

  $inputs = $(iconElement).prevAll('input');

  $inputs.each(function () {
    $input = $(this);
    if ($input.attr('type') === 'password') {
      $input.attr('type', 'text');
      $(iconElement).removeClass('icon-eye').addClass('icon-hide');
    } else {
      $input.attr('type', 'password');
      $(iconElement).removeClass('icon-hide').addClass('icon-eye');
    }
  })

}


function getOTP() {

  return $inputs.map(function () {
    return $(this).val();
  }).get().join("");
}

function checkAndSubmit(actionUrl, data) {

  otp = getOTP();
  if (otp.length === $inputs.length && /^\d+$/.test(otp)) {
    submitOTP(otp, actionUrl, data);
  }
}
// In-flight guard: the PIN/OTP submission can be triggered twice for one entry -
// the 4th digit's input event auto-submits, and an Enter keystroke right after it
// lands on the form-submit handler. The duplicate reaches the server AFTER the
// login committed and is bounced by the Guest middleware (402 "session active"),
// clobbering the success handling of the first request.
var otpSubmitInFlight = false;
function allow_resend_in(allow_resend_in) {
  if (allow_resend_in != 0) {
    $('.RequestOtp_s').attr('disabled', true);

    timeout = setTimeout(function () {
      $('.RequestOtp_s').attr('disabled', false);
    }, allow_resend_in * 1000);
  } else {
    $('.RequestOtp_s').removeAttr("disabled");
  }
}
function submitOTP(otp, actionUrl, data) {

  if (otpSubmitInFlight) return;
  otpSubmitInFlight = true;

  $('.verify_Otp').show().css('display', 'flex');
  $('[class$="_option"]').addClass('hide');
  $('.error-message').html('');
  // #resend / #channelFallback: the OTP step-type toggle owns their disabled
  // state - it is ROUTING (which hidden key the resend form posts), not UI.
  // A blanket toggle here once resurrected channel_fallback on the SMS step,
  // so every resend posted a phantom channel switch (2026-08-20).
  $('input:not(#resend):not(#channelFallback) , select').attr("disabled", "disabled")
  // Scope to the form that actually owns the OTP inputs ($inputs, set by the
  // input/paste handlers from the element that fired the event), not "whichever
  // form isn't hidden": OTP inputs use autocomplete="one-time-code", so OS/browser
  // SMS autofill can still fire on them after the UI has moved past the OTP step
  // (form hidden, not removed). Querying the visible form then finds no
  // .otp_container, `d` comes back undefined, and the code is posted under the
  // literal key "undefined".
  $otpForm = $inputs.closest('form');
  d = $otpForm.find('.otp_container').attr('name');
  if (data == undefined) {
    data = {};

  }
  if ($otpForm.find('[name="form"]').length) {
    f = $otpForm.find('[name="form"]').val();
    data['form'] = f;
  }
  data['_token'] = $('[name="_token"]').val();
  data[d] = otp;

  var ajaxConfig = {
    url: actionUrl, // Replace with your endpoint
    type: "POST",
    data: data,
    beforeSend: function () {
      $('.error-message , .success-message').html('');
      $('#quickLogin_form').find('.submitText').hide().end().find('.loading').show();
      if (window.location.href.includes('auth')) {
        $.notifyOtherTabsOnAuthResponse(undefined, authWorker);
      }

    },
    complete: function () {
      otpSubmitInFlight = false;
    },
    success: function (data) {
      $('input:not(#resend):not(#channelFallback)  , select').removeAttr("disabled")
      if (window.location.href.includes('auth')) {
        processFormInTabsAndTrackEvent(data, $('#otpverification'), function () {
          submitOTP(otp, actionUrl);
        })
        //hide Loader from other tabs
        if (data.success == false) {
          $.notifyOtherTabsOnAuthResponse(false, authWorker);
          // A failure response without authData (e.g. a middleware bounce like 402)
          // never reaches applyAuthDataOnPage, which is what normally hides this.
          $('.verify_Otp').hide();
        }

      } else {
        //Dashbord otp
        $('.verify_Otp').hide();
        /*
         * Reset ONLY the forms hosting the OTP digit inputs (so a wrong code can be
         * retyped) - never every form on the page: the page-wide reset wiped the
         * fields of whatever form sat behind the vetting modal (the mobile form
         * first, then the domain-move form's target email + terms checkbox).
         */
        $(".otp_container").closest("form:not(#mobile_form)").trigger('reset');
        $('.otp_container input , #toogle-require-2fa').removeAttr("disabled");
        if (typeof data.data.allow_resend_in !== 'undefined') {
          allow_resend_in(data.data.allow_resend_in);
        }
        checkForJWTToken(data)
        if (data.success == false) {
          $('.error-message').append(data.msg);
           $('.error-message').show();
          $.alertHandler("", data.msg, alert_box_failure);
          return
        } else $.alertHandler("", data.data.resumed_action.result.msg ? data.data.resumed_action.result.msg : data.msg, alert_box_success);
        // identity Vetting
        checkForIdentityVetting(data)

     




      
      }
    },

  };

  //  Add headers ONLY if token exists from previous request
  if (typeof resumeActionToken !== 'undefined' && resumeActionToken && resumeActionToken.trim() !== '') {
    ajaxConfig.headers = {
      'X-Resume-Action-Token': resumeActionToken.trim()
    };
  }
  // execute the AJAX request
  $.ajax(new $.ajax_prototype(ajaxConfig));

}
$(document).ready(function () {

  $inputs = $(document.querySelectorAll("form:not(.hide) .otp-input"));
  $(document).on("input", ".otp-input", function (e) {
    $inputs = $(this).closest('form').find('.otp-input'); //$(document.querySelectorAll("form:not(.hide) .otp-input"))

    actionUrl = $inputs.closest('form').attr('action');

    $shouldAutoSubmit = true;
    if ($("form:not(.hide) .otp_container").attr('auto-submit') != undefined) {
      $shouldAutoSubmit = false;
    }
    $this = $(this);
    index = $inputs.index(this);
    value = $this.val().replace(/\D/g, '');

    if (value.length > 1) {
      // Paste case
      chars = value.split('');
      chars.forEach(function (char, i) {
        if (index + i < $inputs.length) {
          $inputs.eq(index + i).val(char);
        }
      });
      focusOtpInput($inputs.eq(Math.min(index + chars.length, $inputs.length - 1)));
    } else {
      $this.val(value);
      if (value && index < $inputs.length - 1) {
        focusOtpInput($inputs.eq(index + 1));
      }
    }
    if ($shouldAutoSubmit)
      checkAndSubmit(actionUrl);
  });
  $(document).on("keydown", ".otp-input", function (e) {
    $this = $(this);

    $inputs = $(this).closest('form').find('.otp-input');
    actionUrl = $inputs.closest('form').attr('action');
    index = $inputs.index(this);
    if (e.key === "Backspace" && !$this.val() && index > 0) {
      focusOtpInput($inputs.eq(index - 1));
    }
  });
  $(document).on("paste contextmenu", ".otp-input", function (e) {
    // Prevent default action to handle custom paste logic
    e.preventDefault();

    $shouldAutoSubmit = true;

    // Check if auto-submit is enabled (based on attribute)
    if ($("form:not(.hide) .otp_container").attr('auto-submit') !== undefined) {
      $shouldAutoSubmit = false;
    }

    $inputs = $(this).closest('form').find('.otp-input');
    actionUrl = $inputs.closest('form').attr('action');
    // If the event is a paste event, we can safely access clipboardData
    paste = '';
    if (e.type === "paste") {
      paste = (e.originalEvent || e).clipboardData.getData("text").replace(/\D/g, '');
    } else if (e.type === "contextmenu") {
      // For contextmenu, delay reading clipboard data to ensure it's available after the menu is opened
      setTimeout(function () {
        navigator.clipboard.readText().then(function (text) {
          paste = text.replace(/\D/g, '');
          processPaste(paste);
        }).catch(function (err) {
          console.error("Failed to read clipboard data:", err);
        });
      }, 100);
      return; // Prevent further processing until clipboard data is fetched
    }

    if (paste) {
      processPaste(paste);
    }

    // Function to handle pasting text into the input fields
    function processPaste(paste) {
      for (i = 0; i < $inputs.length; i++) {
        $inputs.eq(i).val(paste[i] || '');
      }
      // Focus on the next input or the last one based on paste length
      focusOtpInput($inputs.eq(Math.min(paste.length, $inputs.length - 1)));

      // If auto-submit is enabled, submit the form
      if ($shouldAutoSubmit) {
        (typeof actionUrl !== 'undefined')
        checkAndSubmit(actionUrl);
      }
    }
  });

  // Enter (or a password-manager autofill followed by Enter) inside an OTP/PIN form
  // triggers the browser's IMPLICIT form submission - a native request that bypasses
  // submitOTP entirely. The auth forms declare no method, so the digits ended up in
  // the URL as a GET query string. Route it into the same guarded auto-submit path
  // instead (no-op until every digit is present).
  $(document).on('submit', 'form', function (e) {
    if ($(this).find('.otp-input').length === 0) return;
    e.preventDefault();
    $inputs = $(this).find('.otp-input');
    checkAndSubmit($(this).attr('action'));
  });

  $(document.querySelectorAll("form:not(.hide) .otp-input")).eq(0).focus();
});

